import { useTheme, useMediaQuery, Button, Input, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Tutorial from './tuto';
import { useLocation, useNavigate } from 'react-router-dom';
import foodData from './food';
import { API_URL } from './tools/consts';

const plateauIndex = Math.floor(Math.random() * 8);

export default function GamePage() {
    const plateauUrl = ["plateau joueur automne festif", "plateau joueur automne", "plateau joueur été festif", "plateau joueur été", "plateau joueur hiver festif", "plateau joueur hiver", "plateau joueur printemps festif", "plateau joueur printemps"]
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const { firstTry = true, pseudo } = location.state || {};
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [isClose, setIsClose] = useState(true);
    const [gameStep, setGameStep] = useState(1);
    const [words, setWords] = useState([]);
    const [alternatives, setAlternatives] = useState([]);
    const [seasons, setSeasons] = useState(["printemps", "été", "hiver"]);
    const [secondSeasons, setSecondSeasons] = useState(["null", "printemps", "null"]);
    const [thirdSeasons, setThirdSeasons] = useState(["null", "printemps", "null"]);
    const [fourthSeasons, setFourthSeasons] = useState(["null", "printemps", "null"]);
    const [firstSeasonPoint, setFirstSeasonPoint] = useState([]);
    const [secondSeasonPoint, setSecondSeasonPoint] = useState([]);
    const [thirdSeasonPoint, setThirdSeasonPoint] = useState([]);
    const [fourthSeasonPoint, setFourthSeasonPoint] = useState([]);
    const [currentWordIndex, setCurrentWordIndex] = useState(0);
    const [images, setImages] = useState([]);
    const [guessword, setGuessWord] = useState("");
    const [revealedWord, setRevealedWord] = useState("");
    const [score, setScore] = useState(0);
    const [plateauIndex, setPlateauIndex] = useState(0);

    useEffect(() => {
        setPlateauIndex(Math.floor(Math.random() * plateauUrl.length));
    }, [])

    useEffect(() => {
        selectRandomFoods();
    }, []);

    useEffect(() => {
        console.log(gameStep);
        if (gameStep === 5) {
            console.log("navigate");
            const submitScore = async () => {
                await postScorePoints(pseudo, score);
                navigate(`/score/${score}/${pseudo}`);
            };
            submitScore();
        }
    }, [gameStep, navigate, pseudo, score]);

    const handleClose = () => setIsClose(false);
    const selectRandomFoods = () => {
        const randomIndices = [];
        const totalItems = foodData.length;

        while (randomIndices.length < 6) {
            const randomIndex = Math.floor(Math.random() * totalItems);
            if (!randomIndices.includes(randomIndex)) {
                randomIndices.push(randomIndex);
            }
        }

        const selectedFoods = randomIndices.map(index => foodData[index]);

        const words = selectedFoods.map(food => food.name);
        const alternatives = selectedFoods.map(food => food.alternatives);
        const seasons = selectedFoods.map(food => food.season);
        const secondSeasons = selectedFoods.map(food => food.secondSeason || "null");
        const thirdSeasons = selectedFoods.map(food => food.thirdSeason || "null");
        const fourthSeason = selectedFoods.map(food => food.fourthSeason || "null");
        const firstSeasonPoint = selectedFoods.map(food => food.pointsSeason || 0);
        const secondSeasonPoint = selectedFoods.map(food => food.pointsSecondSeason || 0);
        const thirdSeasonPoint = selectedFoods.map(food => food.pointsThirdSeason || 0);
        const fourthSeasonPoint = selectedFoods.map(food => food.pointsFourthSeason || 0);
        const image = selectedFoods.map(food => food.image);

        setAlternatives(alternatives);
        setWords(words);
        setSeasons(seasons);
        setSecondSeasons(secondSeasons);
        setThirdSeasons(thirdSeasons);
        setFourthSeasons(fourthSeason);
        setRevealedWord(
            words[0].split('').map(char => (char === ' ' ? ' ' : '_')).join('')
        );        

        setFirstSeasonPoint(firstSeasonPoint);
        setSecondSeasonPoint(secondSeasonPoint);
        setThirdSeasonPoint(thirdSeasonPoint);
        setFourthSeasonPoint(fourthSeasonPoint);
        setImages(image);
    }

    const handleSubmit = () => {
        const word = words[currentWordIndex];
        const alternative = alternatives[currentWordIndex].map(element => element.toLowerCase());

        if (gameStep === 1) {
            if (guessword.toLowerCase().trim() === word.toLowerCase() || alternative.includes(guessword.toLowerCase().trim())) {
                setScore(score + 6);
                setGameStep(4);
            } else {
                setGameStep(2);
                revealOneLetter();
            }
        } else if (gameStep === 2) {
            if (guessword.toLowerCase().trim() === word.toLowerCase() || alternative.includes(guessword.toLowerCase().trim())) {
                setScore(score + 4);
                setGameStep(4);
            } else {
                setGameStep(3);
                revealOneLetter();
            }
        } else if (gameStep === 3) {
            if (guessword.toLowerCase().trim() === word.toLowerCase() || alternative.includes(guessword.toLowerCase().trim())) {
                setScore(score + 2);
                setGameStep(4);
            } else {
                moveToNextWord();
            }
        } else if (gameStep === 4) {
            if (guessword.toLowerCase().trim() === word.toLowerCase() || alternative.includes(guessword.toLowerCase().trim())) {
                setScore(score + 1);

                setGameStep(5);
            } else {
                setGameStep(5);
            }
        } else if (gameStep === 5) {
            moveToNextWord();
        }
        setGuessWord("");
    };


    const postScorePoints = async (pseudo, score) => {
        console.log(score);
        const qr = await fetch(API_URL + "players/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                username: pseudo,
                points: score,
                created_at: new Date()
            }),
        });
        console.log(qr)
    }

    const revealOneLetter = () => {
        const word = words[currentWordIndex];
        let updatedWord = revealedWord.split('');
        let wordArray = word.split('');
    
        let unrevealedIndices = updatedWord
            .map((char, index) => (char === '_' && wordArray[index] !== ' ' ? index : null))
            .filter(index => index !== null);
    
        if (unrevealedIndices.length > 0) {
            const randomIndex = Math.floor(Math.random() * unrevealedIndices.length);
            const revealIndex = unrevealedIndices[randomIndex];
            updatedWord[revealIndex] = wordArray[revealIndex];
            setRevealedWord(updatedWord.join(''));
        }
    };
    
    const moveToNextWord = () => {
        if (currentWordIndex < words.length - 1) {
            const nextWord = words[currentWordIndex + 1];
            setCurrentWordIndex(currentWordIndex + 1);
            setRevealedWord("_".repeat(nextWord.length));
            setRevealedWord(
                nextWord.split('').map(char => (char === ' ' ? ' ' : '_')).join('')
            );            
            console.log(nextWord);
            setGuessWord("");
            setGameStep(1);
        } else {
            setGameStep(5);
        }
    };

    const submitSaision = (saison) => {
        if (gameStep === 4) {
            if (saison === seasons[currentWordIndex]) {
                setScore(score + firstSeasonPoint[currentWordIndex]);
            } else if (saison === secondSeasons[currentWordIndex] || saison === thirdSeasons[currentWordIndex]) {
                setScore(score + secondSeasonPoint[currentWordIndex]);
            } else if (saison === thirdSeasons[currentWordIndex]) {
                setScore(score + thirdSeasonPoint[currentWordIndex]);
            } else if (saison === fourthSeasons[currentWordIndex]) {
                setScore(score + fourthSeasonPoint[currentWordIndex]);
            }
            moveToNextWord();
        }
    };

    useEffect(() => {
        setIsClose(true);
    }, [location.pathname]);

    return (
        <div
            style={{
                backgroundImage: `url('/_ART/PLATEAUX/${plateauUrl[plateauIndex]}.png')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100vw',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                position: 'relative',
            }}
        >
            {isClose && firstTry ? (
                <Tutorial onClose={handleClose} pseudo={pseudo} />
            ) : (
                <>
                    <div style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        backgroundColor: 'black',
                        padding: '10px',
                        borderRadius: '5px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>

                        <Typography variant="h6" style={{ margin: 0, color: 'white' }}>
                            {pseudo} | {score} pts
                        </Typography>
                    </div>
                    {gameStep !== 4 && gameStep !== 5 && (

                        <Typography
                            variant="h4"
                            style={{
                                color: 'white',
                                backgroundColor: 'black',
                                position: 'absolute',
                                top: isMobile ? '22vh' : '16vh',
                                left: isMobile ? '5vw' : '30vw',
                                border: '5px ',
                                borderRadius: '10px',
                                padding: '10px',
                                transform: 'rotate(-10deg)',
                            }}
                        >
                            {gameStep === 1 || gameStep === 2 || gameStep === 3
                                ? revealedWord
                                : `${words[currentWordIndex]}`}
                        </Typography>)}

                    {gameStep !== 4 && gameStep !== 5 && (
                        <>
                            <div style={{ backgroundColor: 'white', borderRadius: '20px', width: isMobile ? '90vw' : '30vw', height: '45vh' }}>
                                <img src={`/food/${images[currentWordIndex]}.jpg`} alt="plateau joueur hiver" style={{ width: isMobile ? '90vw' : '30vw', height: '45vh' }} />
                            </div>
                            <Input
                                style={{ backgroundColor: 'white', marginTop: '6%' }}
                                value={guessword}
                                color="success"
                                onChange={(e) => setGuessWord(e.target.value)}
                            />
                            <Button variant="contained" color="success" onClick={handleSubmit} style={{ marginTop: '4%' }}>Valider</Button>
                        </>
                    )}
                    {gameStep === 4 && (
                        <>
                            {/* Texte centré en haut */}
                            <Typography
                                variant="h5"
                                style={{
                                    position: 'absolute',
                                    top: isMobile ? '10vh' : '12vh',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    color: 'white',
                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                    padding: '10px 20px',
                                    borderRadius: '10px',
                                    textAlign: 'center',
                                    fontSize: '21px'
                                }}
                            >
                                Choisis la saison !
                            </Typography>
                            <div
                                style={{
                                    borderRadius: '20px',
                                    width: isMobile ? '90vw' : '30vw',
                                    height: '45vh',
                                    position: 'relative', // Important pour positionner les mots par rapport à cette div
                                }}
                            >
                                <img
                                    src={`/reveal/${images[currentWordIndex]}.jpg`}
                                    alt="plateau joueur hiver"
                                    style={{
                                        width: isMobile ? '90vw' : '30vw',
                                        height: '45vh',
                                        borderRadius: '20px',
                                    }}
                                />
                                {/* Mot "bonjour" aux quatre coins */}
                                <Typography
                                    style={{
                                        position: 'absolute',
                                        top: '-0.5em',
                                        left: '1em',
                                        color: 'black',
                                        padding: '5px',
                                        borderRadius: '5px',
                                        fontSize: '12px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Printemps
                                </Typography>

                                <Typography
                                    style={{
                                        position: 'absolute',
                                        top: '-0.5em',
                                        right: '2.5em',
                                        color: 'black',
                                        padding: '5px',
                                        borderRadius: '5px',
                                        fontSize: '12px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Eté
                                </Typography>
                                <Typography
                                    style={{
                                        position: 'absolute',
                                        bottom: '-0.5em',
                                        left: '2.5em',
                                        color: 'black',
                                        padding: '5px',
                                        borderRadius: '5px',
                                        fontSize: '12px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Hiver
                                </Typography>
                                <Typography
                                    style={{
                                        position: 'absolute',
                                        bottom: '-0.5em',
                                        right: '1em',
                                        color: 'black',
                                        padding: '5px',
                                        borderRadius: '5px',
                                        fontSize: '12px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Automne
                                </Typography>
                            </div>
                            <div onClick={() => submitSaision("printemps")} style={{ position: 'absolute', top: '28vh', cursor: 'pointer', left: isMobile ? '5vw' : '36vw', width: isMobile ? '25vw' : '8vw', height: isMobile ? '13vh' : '10vh' }}>
                            </div>
                            <div onClick={() => submitSaision("été")} style={{ position: 'absolute', top: '28vh', cursor: 'pointer', right: isMobile ? '5vw' : '36vw', width: isMobile ? '25vw' : '8vw', height: isMobile ? '13vh' : '10vh' }}>
                            </div>
                            <div onClick={() => submitSaision("hiver")} style={{ position: 'absolute', bottom: isMobile ? '27vh' : '28vh', cursor: 'pointer', left: isMobile ? '5vw' : '36vw', width: isMobile ? '25vw' : '8vw', height: isMobile ? '13vh' : '10vh' }}>
                            </div>
                            <div onClick={() => submitSaision("automne")} style={{ position: 'absolute', bottom: isMobile ? '27vh' : '28vh', cursor: 'pointer', right: isMobile ? '5vw' : '36vw', width: isMobile ? '25vw' : '8vw', height: isMobile ? '13vh' : '10vh' }}>

                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
}
